import * as types from '../actions/action-types'

let preloadedGoBackToVehicleTest = null
try {
  const item = sessionStorage.getItem('goBackToVehicleTest')
  preloadedGoBackToVehicleTest = JSON.parse(item)
} catch (e) {}

const initialState = {
  pathname:
    (preloadedGoBackToVehicleTest && preloadedGoBackToVehicleTest.pathname) ??
    null,
  vin:
    (preloadedGoBackToVehicleTest && preloadedGoBackToVehicleTest.vin) ?? null,
}

const goBackToVehicleTestReducer = function (state = initialState, action) {
  switch (action.type) {
    case types.SET_GO_BACK_TO_VEHICLE_TEST:
      return Object.assign({}, state, {
        pathname: action.pathname,
        vin: action.vin,
      })
    case types.RESET_GO_BACK_TO_VEHICLE_TEST:
      return Object.assign({}, state, {
        pathname: initialState.pathname,
        vin: initialState.vin,
      })
    default:
      return state
  }
}

export default goBackToVehicleTestReducer
